module.exports = __webpack_public_path__ + "assets/ddd4e0ab73f74a91d6a143b8beff6350.mp3";